import { useDeviceTesterStateContext } from "../device-tester-context-provider/DeviceTesterContextProvider";

import { PermissionDeniedPopup } from "./PermissionDeniedPopup";

export const ConnectedPermissionDeniedPopup: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();

  return (
    <PermissionDeniedPopup
      cameraAccess={deviceTesterState.deviceSettings.cameraAccess}
      micAccess={deviceTesterState.deviceSettings.micAccess}
      isInfoFetched={deviceTesterState.isInfoFetched}
    />
  );
};
